<template>
    <v-card-text>
        <v-row class="mx-0" align="center" justify="end">
            <v-col cols="12" sm="auto" class="px-0">
                <v-btn color="primary" tile depressed @click="openDialog = true"
                    class="w-100 w-sm-auto font-weight-bold create-webinar-btn">
                    Create Real-Life Training
                </v-btn>
            </v-col>
        </v-row>

        <!--  Create Real-Life Training Form  -->
        <v-dialog v-model="openDialog" max-width="800px">
            <v-card class="mx-auto px-5 py-3" max-width="800px" outlined style="max-height: 90vh; overflow-y: auto">
                <v-row align="center" justify="space-between" class="mt-1 mx-0">
                    <v-col cols="10">
                        <h2 class="text-h4 font-weight-light">Real-Life Training</h2>
                    </v-col>
                    <v-col cols="2" class="text-right">
                        <v-btn icon color="grey darken-1" @click="openDialog = false">
                            <v-icon class="dialog-close-icon" size="22">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-card-text>
                    <v-form>
                        <v-row class="mt-4" no-gutters>
                            <v-col cols="12">
                                <h4 class="text-left text-break mb-2">Title</h4>
                                <v-text-field v-model="title" label="Title" outlined dense placeholder="Training Title"
                                    :error-messages="errorTitle"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <h4 class="text-left text-break mb-2">Format</h4>
                                <v-text-field v-model="format" label="Training Format" outlined dense
                                    placeholder="Training format" :error-messages="errorFormat"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <h4 class="text-left text-break mb-2">Audience</h4>
                                <v-text-field v-model="audience" label="Audience Details" outlined dense
                                    placeholder="Audience Details" :error-messages="errorAudience"></v-text-field>
                            </v-col>

                            <v-col cols="12" class="mb-2">
                                <h4 class="text-left text-break mb-2">Dates</h4>
                                <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition"
                                    offset-y min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                            <v-row dense>
                                                <v-col v-for="(date, index) in sortedDisplayDates" :key="index" cols="6"
                                                    sm="4" md="3">
                                                    <v-text-field :value="date" :label="`Date ${index + 1}`" outlined
                                                        dense readonly hide-details
                                                        append-icon="mdi-calendar-check"></v-text-field>
                                                </v-col>

                                                <v-col cols="6" sm="4" md="3">
                                                    <v-text-field value=""
                                                        :label="dates.length > 0 ? 'Add Date' : 'Select Date'"
                                                        placeholder="Click to add..." outlined dense readonly
                                                        :error-messages="errorDates" hide-details="auto"
                                                        append-icon="mdi-plus"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="dates" multiple no-title scrollable></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" class="mt-4">
                                <h4 class="text-left text-break mb-2">Price</h4>
                                <v-text-field v-model="price" label="Training Price" type="number" outlined dense
                                    prefix="€" placeholder="0.00" min="0" :error-messages="errorPrice"></v-text-field>
                            </v-col>

                            <v-col cols="12" class="mb-4">
                                <h4 class="text-left text-break mb-2">Why this training?</h4>
                                <quill-editor v-model="whyTraining" ref="whyTrainingEditor" :options="editorOption"
                                    class="mb-2" :class="{ 'error-border': !!errorWhyTraining }" />

                                <div v-if="errorWhyTraining" class="v-text-field__details mt-2 ml-2">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">{{ errorWhyTraining }}</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12" class="mb-4">
                                <h4 class="text-left text-break mb-2">Programme</h4>
                                <quill-editor v-model="programme" ref="programmeEditor" :options="editorOption"
                                    class="mb-2" :class="{ 'error-border': !!errorProgramme }"/>

                                <div v-if="errorProgramme" class="v-text-field__details mt-2 ml-2">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">{{ errorProgramme }}</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12">
                                <h4 class="text-left text-break mb-2">Registration Link</h4>
                                <v-text-field v-model="registrationLink" label="Training Registration Link" outlined
                                    dense placeholder="https://example.com/register"
                                    :error-messages="errorRegistrationLink"></v-text-field>
                            </v-col>

                            <v-col cols="12" class="mt-2">
                                <h4 class="text-left text-break mb-2">Training Terms & Conditions</h4>
                                <quill-editor v-model="termsAndConditions" ref="termsEditor" :options="editorOption"
                                    class="mb-2" :class="{ 'error-border': !!errorTerms }" />

                                <div v-if="errorTerms" class="v-text-field__details mt-2 ml-2">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">{{ errorTerms }}</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-row justify="center" class="mb-6 mt-4">
                    <v-btn class="create-webinar-btn" color="secondary" dark depressed @click="submitTraining"
                        :loading="isLoading">
                        Create Training
                    </v-btn>
                </v-row>
            </v-card>
        </v-dialog>

        <!--  Delete Confirmation Dialog  -->
        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <h3 class="title text-start"> Are you sure you want to delete this training? </h3>
                </v-card-title>
                <v-card-text>
                    <p class="subtitle-2 text-left"> You will be permanently deleting all the data associated with this
                        training session.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false"> No, Cancel </v-btn>
                    <v-btn color="error" text @click="confirmDelete" :loading="isLoading"> Yes, Delete </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="loadingData" class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <!-- Real-Life Training List -->
        <div v-else class="mt-5">
            <v-data-iterator :items="trainings" :items-per-page.sync="itemsPerPage" :page.sync="page"
                :footer-props="footerProps" hide-default-header>
                <template v-slot:default="props">

                    <v-card v-for="(item, index) in props.items" :key="item._id || index"
                        class="mb-10 pa-6 d-flex flex-column" outlined height="100%">

                        <div class="flex-grow-1">
                            <div class="d-flex justify-space-between align-start mb-4">
                                <div style="width: 80px;" class="d-none d-sm-block"></div>

                                <div class="text-center flex-grow-1 mx-2">
                                    <h2 class="text-h5 font-weight-bold text-break">{{ item.title }}</h2>
                                </div>

                                <div style="width: 80px;" class="d-flex justify-end">
                                    <v-btn color="red" depressed small @click="openDeleteDialog(item._id)"
                                        class="create-webinar-btn font-weight-bold"
                                        :class="$vuetify.breakpoint.smAndDown ? 'ml-0 mt-2' : 'ml-4'">
                                        <v-icon left small>mdi-delete</v-icon> DELETE
                                    </v-btn>
                                </div>
                            </div>

                            <div class="mb-2">
                                <v-row dense no-gutters class="text-body-1">
                                    <v-col cols="12" sm="2" class="font-weight-bold mb-0">Format:</v-col>
                                    <v-col cols="12" sm="10" class="mb-2">{{ item.format }}</v-col>

                                    <v-col cols="12" sm="2" class="font-weight-bold mb-0">Audience:</v-col>
                                    <v-col cols="12" sm="10" class="mb-2">{{ item.audience }}</v-col>

                                    <v-col cols="12" sm="2" class="font-weight-bold mb-0">Date:</v-col>
                                    <v-col cols="12" sm="10" class="mb-2">{{ formatDatesList(item.dates) }}</v-col>

                                    <v-col cols="12" sm="2" class="font-weight-bold mb-0">Price:</v-col>
                                    <v-col cols="12" sm="10" class="mb-2">
                                        €{{ item.price }}
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="mb-2">
                                <h3 class="text-h6 font-weight-bold mb-1">Why this training?</h3>
                                <div class="text-body-2 grey--text text--darken-3 quill-content">
                                    <div v-html="item.whyTraining"></div>
                                </div>
                            </div>

                            <div class="mb-5">
                                <h3 class="text-h6 font-weight-bold mb-1">Programme</h3>
                                <div class="text-body-2 grey--text text--darken-3 quill-content">
                                    <div v-html="item.programme"></div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-auto">
                            <div class="mb-5">
                                <v-row>
                                    <v-col cols="12" md="4" sm="6">
                                        <v-btn small height="32" color="primary" depressed block
                                            :href="item.registrationLink" target="_blank"
                                            class="create-webinar-btn subtitle-2 letter-spacing-1 font-weight-bold">
                                            SIGN UP
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>

                            <div>
                                <h3 class="text-h6 font-weight-bold mb-1">Training Terms & Conditions</h3>
                                <div class="caption grey--text text--darken-2 quill-content">
                                    <div v-html="item.termsAndConditions"></div>
                                </div>
                            </div>
                        </div>
                    </v-card>

                </template>

                <template v-slot:no-data>
                    <p class="text-center grey--text mt-5">No training sessions found.</p>
                </template>
            </v-data-iterator>
        </div>

    </v-card-text>
</template>

<script>
import ContentService from "../../../services/content.service";

// QUILL EDITOR IMPORTS
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
    name: "Training",
    components: {
        quillEditor
    },
    data: () => ({
        isLoading: false,
        loadingData: false,
        trainings: [],
        openDialog: false,
        deleteDialog: false,
        trainingToDeleteId: null,

        // Pagination Data
        page: 1,
        itemsPerPage: 5,
        footerProps: {
            "items-per-page-options": [5, 10, 20, -1],
            "show-current-page": true,
            "show-first-last-page": true
        },

        dateMenu: false,

        // Form Data
        title: '',
        format: '',
        audience: '',
        dates: [],
        price: null,
        whyTraining: '',
        programme: '',
        registrationLink: '',
        termsAndConditions: '',

        // Errors
        errorTitle: null,
        errorFormat: null,
        errorAudience: null,
        errorDates: null,
        errorPrice: null,
        errorWhyTraining: null,
        errorProgramme: null,
        errorRegistrationLink: null,
        errorTerms: null,

        // EDITOR OPTIONS
        editorOption: {
            placeholder: 'Enter details here...',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean']
                ]
            }
        },
    }),
    computed: {
        // Sorts the selected dates chronologically for the display input fields
        sortedDisplayDates() {
            if (!this.dates || this.dates.length === 0) return [];
            return [...this.dates].sort((a, b) => new Date(a) - new Date(b));
        },
        datesDisplay() {
            if (!this.dates || this.dates.length === 0) return "";
            return this.sortedDisplayDates.join(', ');
        }
    },
    mounted() {
        this.fetchTrainings();
    },
    watch: {
        openDialog(val) {
            if (!val) {
                this.resetForm();
            }
        },
        title() { this.errorTitle = null; },
        format() { this.errorFormat = null; },
        audience() { this.errorAudience = null; },
        dates() { this.errorDates = null; },
        price() { this.errorPrice = null; },
        whyTraining() { this.errorWhyTraining = null; },
        programme() { this.errorProgramme = null; },
        termsAndConditions() { this.errorTerms = null; },
        registrationLink() { this.errorRegistrationLink = null; },
    },
    methods: {
        // --- Fetch Data ---
        async fetchTrainings() {
            this.loadingData = true;
            try {
                const response = await ContentService.getTrainings();
                this.trainings = response.data.content || [];
            } catch (error) {
                console.error("Error fetching trainings:", error);
            } finally {
                this.loadingData = false;
            }
        },

        // --- Delete Data ---
        openDeleteDialog(id) {
            this.trainingToDeleteId = id;
            this.deleteDialog = true;
        },
        async confirmDelete() {
            this.isLoading = true;
            try {
                await ContentService.deleteTraining(this.trainingToDeleteId);
                this.$store.dispatch("notify/setSnackbarMessage", {
                    snackBarText: "Training session deleted successfully!",
                    snackBarColor: "green",
                });
                this.fetchTrainings();
            } catch (error) {
                console.error("Error deleting training:", error);
                this.$store.dispatch("notify/setSnackbarMessage", {
                    snackBarText: "Error deleting the training session.",
                    snackBarColor: "red",
                });
            } finally {
                this.deleteDialog = false;
                this.trainingToDeleteId = null;
                this.isLoading = false;
            }
        },

        // Helper to format array of dates for the list view
        formatDatesList(dateArray) {
            if (!dateArray || !Array.isArray(dateArray) || dateArray.length === 0) return "Date TBD";

            const sorted = [...dateArray].sort((a, b) => new Date(a) - new Date(b));

            const getDayWithSuffix = (day) => {
                if (day > 3 && day < 21) return `${day}th`;
                switch (day % 10) {
                    case 1: return `${day}st`;
                    case 2: return `${day}nd`;
                    case 3: return `${day}rd`;
                    default: return `${day}th`;
                }
            };

            return sorted
                .map(dateStr => {
                    const date = new Date(dateStr);
                    const day = getDayWithSuffix(date.getUTCDate());
                    const month = date.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
                    const year = date.getUTCFullYear();
                    return `${day} of ${month} ${year}`;
                }).join(' / ');
        },

        // --- Submit Data ---
        async submitTraining() {
            const isValid = this.validateForm();
            if (isValid) {
                this.isLoading = true;

                try {
                    const sortedDatesPayload = [...this.dates].sort((a, b) => new Date(a) - new Date(b));

                    const trainingData = {
                        title: this.title,
                        format: this.format,
                        audience: this.audience,
                        dates: sortedDatesPayload,
                        price: Number(this.price),
                        whyTraining: this.whyTraining,
                        programme: this.programme,
                        registrationLink: this.registrationLink,
                        termsAndConditions: this.termsAndConditions
                    };

                    await ContentService.createTraining(trainingData);

                    this.$store.dispatch("notify/setSnackbarMessage", {
                        snackBarText: "Training session created successfully!",
                        snackBarColor: "green",
                    });

                    this.openDialog = false;
                    this.fetchTrainings();
                } catch (error) {
                    console.error("Error creating training:", error);
                    this.$store.dispatch("notify/setSnackbarMessage", {
                        snackBarText: "There was an error creating the training session.",
                        snackBarColor: "red",
                    });
                } finally {
                    this.isLoading = false;
                }
            }
        },
        validateForm() {
            let isValid = true;

            if (!this.title.trim()) {
                this.errorTitle = 'Title is required.';
                isValid = false;
            }
            if (!this.format.trim()) {
                this.errorFormat = 'Format is required.';
                isValid = false;
            }
            if (!this.audience.trim()) {
                this.errorAudience = 'Audience is required.';
                isValid = false;
            }
            if (!this.dates || this.dates.length === 0) {
                this.errorDates = 'At least one date is required.';
                isValid = false;
            }
            if (!this.price && this.price !== 0) {
                this.errorPrice = 'Price is required.';
                isValid = false;
            }
            // Check HTML content length or trim
            if (!this.whyTraining || this.whyTraining === '<p><br></p>') {
                this.errorWhyTraining = 'Reason for training is required.';
                isValid = false;
            }
            if (!this.programme || this.programme === '<p><br></p>') {
                this.errorProgramme = 'Programme details are required.';
                isValid = false;
            }
            if (!this.termsAndConditions || this.termsAndConditions === '<p><br></p>') {
                this.errorTerms = 'Terms are required.';
                isValid = false;
            }

            if (!this.registrationLink.trim()) {
                this.errorRegistrationLink = 'Registration link is required.';
                isValid = false;
            } else {
                const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
                if (!urlPattern.test(this.registrationLink)) {
                    this.errorRegistrationLink = 'Please enter a valid registration link.';
                    isValid = false;
                }
            }
            return isValid;
        },
        resetForm() {
            this.title = '';
            this.format = '';
            this.audience = '';
            this.dates = [];
            this.price = null;
            this.whyTraining = '';
            this.programme = '';
            this.registrationLink = '';
            this.termsAndConditions = '';

            this.errorTitle = null;
            this.errorFormat = null;
            this.errorAudience = null;
            this.errorDates = null;
            this.errorPrice = null;
            this.errorWhyTraining = null;
            this.errorProgramme = null;
            this.errorRegistrationLink = null;
            this.errorTerms = null;
        }
    }
};
</script>

<style scoped>
.create-webinar-btn:hover {
    filter: brightness(85%);
    transition: filter 0.2s ease-in-out;
}

/* --- QUILL EDITOR INPUT STYLING --- */
::v-deep .ql-editor {
    min-height: 150px;
    font-size: 16px;
}

::v-deep .ql-editor li {
    margin-left: 0px;
}

::v-deep .ql-editor ul,
::v-deep .ql-editor ol {
    padding-left: 32px !important;
    margin-bottom: 16px !important;
}

::v-deep .ql-editor ul li {
    list-style-type: disc !important;
}

::v-deep .ql-editor ol li {
    list-style-type: decimal !important;
}

::v-deep .ql-editor strong,
::v-deep .ql-editor b {
    font-weight: bold !important;
}

/* --- QUILL EDITOR DISPLAY STYLING --- */
.quill-content {
    line-height: 1.3 !important;
}

.quill-content ::v-deep p {
    margin-bottom: 4px !important;
    margin-top: 0px !important;
}

.quill-content ::v-deep ul,
.quill-content ::v-deep ol {
    padding-left: 32px !important;
    margin-bottom: 8px !important;
    margin-top: 0px !important;
}

.quill-content ::v-deep li {
    margin-bottom: 2px !important;
}

.quill-content ::v-deep .ql-align-center {
    text-align: center;
}

.quill-content ::v-deep .ql-align-right {
    text-align: right;
}

.quill-content ::v-deep .ql-align-justify {
    text-align: justify;
}

.error-border ::v-deep .ql-toolbar,
.error-border ::v-deep .ql-container {
    border-color: #ff5252 !important;
    border-width: 2.5px;
}
</style>